import { StringRecord } from '@/typings';
import { getFieldIdWithoutIndex } from './getFieldIdWithoutIndex';

/** Total instance count for a repeating group, derived from the FormContext maxItems map. */
export const getGroupInstanceCount = (
  maxItems: StringRecord<{ maxItem: number; id: string }>,
  fieldId: string,
): number => {
  const baseFieldId = getFieldIdWithoutIndex(fieldId);
  const entry = maxItems[baseFieldId];
  return entry ? entry.maxItem + 1 : 1;
};
